{
  "version": "0.0.0",
  "id": "at.softline.lagerhaus.landring.softline",
  "name": "Softline"
}
